import React from 'react';
import Quota from '../../img/quote.png'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/free-regular-svg-icons';
import ReView1 from '../../img/rev (1).jpg'
import ReView2 from '../../img/rev.jpg'
import { Fade } from 'react-reveal';

const Review = () => {

    return (
        <Fade bottom duration={1000} distance="20px">
            <section className="main">
                <h1 className="experience-heading">Says About Me</h1>
                <div className='d-flex'>
                    <div className="col-sm-6 pb-3">
                        <div style={{ borderRadius: '10px' }} className="card shadow p-3 mb-5 bg-body rounded border-0">
                            <div className="card-body p-0 row d-flex ">
                                <div className="col-sm-4 pr-0">
                                    <img style={{ borderRadius: '10px' }} height="100px" src={ReView1} alt="" srcset="" />
                                </div>
                                <div className="col-sm-8 pl-0 review-text">
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <p className="text-secondary my-paragraph">
                                    I really appreciate your work, I am very satisfied with this service! He is very professional and great communicator. Will be back to you soon.
                                    </p>
                                    <div className="row d-flex">
                                        <div className="col-sm-8 ">
                                            <h6 className="my-card-heading">Mizan Shikdar</h6>
                                            <small className="blockquote-footer">Dhaka</small>
                                        </div>
                                        <div className="col-sm-4 text-right">
                                            <img style={{ opacity: '.8' }} height="30px" src={Quota} alt="" srcset="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-sm-6 pb-3">
                        <div style={{ borderRadius: '10px' }} className="card shadow p-3 mb-5 bg-body rounded border-0">
                            <div className="card-body p-0 row d-flex ">
                                <div className="col-sm-4 pr-0">
                                    <img style={{ borderRadius: '10px' }} height="100px" src={ReView2} alt="" srcset="" />
                                </div>
                                <div className="col-sm-8 pl-0 review-text">
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <FontAwesomeIcon style={{ color: '#F7C355' }} icon={faStar} />
                                    <p className="text-secondary my-paragraph">
                                     You Are Great! Whenever I needed changes he was happy to help and make the experience for me as good as possible The sourcecode was also really good.
                                    </p>
                                    <div className="row d-flex">
                                        <div className="col-sm-8 ">
                                            <h6 className="my-card-heading">Md Suresh</h6>
                                            <small className="blockquote-footer">Dhaka</small>
                                        </div>
                                        <div className="col-sm-4 text-right">
                                            <img style={{ opacity: '.8' }} height="30px" src={Quota} alt="" srcset="" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
        </Fade>
    );
};

export default Review;